import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Hero() {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  return (
    <section
      id="hero"
      className="relative min-h-screen bg-cover bg-center flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: "url('/images/background/bg-landing-page.webp')",
      }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/60" />

      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-transparent to-black/80" />

      {/* Content */}
      <div className="relative z-10 text-center text-white" data-aos="fade-up">
        <h1 className="text-4xl md:text-6xl font-bold tracking-widest">
          TITIK SENYAP
        </h1>

        <p className="mt-4 text-sm md:text-lg font-normal tracking-[0.4em] uppercase">
          STUDIO
        </p>
      </div>
    </section>
  );
}
